@let _qaaPrefix = qaaPrefix();
@let _timers = timers();
@let _isLoading = isLoading();
@let _showClientNumbers = showClientNumbers();
@if (_timers) {
  @for (timer of _timers; track timer.id) {
    @let _isPaused = timer.billableItemTimerState === "PAUSED";
    @let _isRunning = timer.billableItemTimerState === "RUNNING";
    @let _canResume = timerActions.canResume(timer);
    @let _clientDisplay =
      _showClientNumbers && timer.clientNumber
        ? `#${timer.clientNumber} ${timer.clientName}`
        : timer.clientName;
    <div
      class="header-timer"
      [attr.data-qaa]="_qaaPrefix + '-timer'"
      [attr.data-qaa-id]="timer.id"
    >
      <f360-lum-tooltip>
        <span
          class="header-timer__client-name"
          [attr.data-qaa]="_qaaPrefix + '-timer-client-name'"
          [attr.data-qaa-id]="timer.id"
          >{{ _clientDisplay }}</span
        >
        <span text>
          <span class="header-timer__tip-line">{{ _clientDisplay }}</span>
          @if (timer.projectId) {
            <i class="header-timer__tip-line">({{ timer | projectdisplay }})</i>
          }
        </span>
      </f360-lum-tooltip>
      @if (_isPaused) {
        <f360-lum-pill
          class="d-none d-md-flex"
          size="small"
          status="warning"
          [data-qaa]="_qaaPrefix + '-paused-badge'"
          [attr.data-qaa-id]="timer.id"
          ><span class="header-timer__paused-label">Paused</span></f360-lum-pill
        >
        <span
          class="d-none d-md-block"
          [attr.data-qaa]="_qaaPrefix + '-paused-duration'"
          [attr.data-qaa-id]="timer.id"
          >{{ timerActions.formatPausedDuration(timer.durationSeconds) }}</span
        >
        @if (!_canResume) {
          <span
            class="header-timer__stale-note"
            [attr.data-qaa]="_qaaPrefix + '-stale-note'"
            [attr.data-qaa-id]="timer.id"
            >Started on a previous day. Finish it and start a new one.</span
          >
        }
      }
      @if (_isRunning) {
        <f360-lum-pill
          class="d-none d-md-flex"
          size="small"
          status="action"
          [data-qaa]="_qaaPrefix + '-running-badge'"
          [attr.data-qaa-id]="timer.id"
          >Running</f360-lum-pill
        >
        <span class="d-none d-md-block">
          <!-- cd-timer reads startTime only once; keying on it re-creates just the timer when a refresh moves it. -->
          @for (durationTimer of [timer]; track durationTimer.durationSeconds) {
            <cd-timer
              format="intelli"
              [startTime]="durationTimer.durationSeconds"
              [attr.data-qaa]="_qaaPrefix + '-running-duration'"
              [attr.data-qaa-id]="timer.id"
            ></cd-timer>
          }
        </span>
      }
      <div class="header-timer__actions">
        @if (_isLoading) {
          <f360-lum-icon
            class="header-timer__spinner"
            name="spinner"
            size="small"
            role="status"
            aria-label="Loading"
            [data-qaa]="_qaaPrefix + '-loading-spinner'"
          />
        }
        @if (_isPaused) {
          <f360-lum-button
            variant="text-only"
            size="medium"
            iconOnly
            severity="action"
            hint="Resume Timer"
            [disabled]="_isLoading || !_canResume"
            (clicked)="timerActions.resume(timer)"
            [data-qaa]="_qaaPrefix + '-resume-button'"
            [attr.data-qaa-id]="timer.id"
          >
            <f360-lum-icon name="play" />
          </f360-lum-button>
        }
        @if (_isRunning) {
          <f360-lum-button
            variant="text-only"
            size="medium"
            iconOnly
            severity="action"
            hint="Pause Timer"
            [disabled]="_isLoading"
            (clicked)="timerActions.pause(timer)"
            [data-qaa]="_qaaPrefix + '-pause-button'"
            [attr.data-qaa-id]="timer.id"
          >
            <f360-lum-icon name="pause" />
          </f360-lum-button>
        }
        <f360-lum-button
          variant="text-only"
          size="medium"
          iconOnly
          severity="action"
          hint="Finish Timer"
          [disabled]="_isLoading"
          (clicked)="timerActions.finish(timer)"
          [data-qaa]="_qaaPrefix + '-finish-button'"
          [attr.data-qaa-id]="timer.id"
        >
          <f360-lum-icon name="check-square" />
        </f360-lum-button>
        <f360-lum-button
          variant="text-only"
          size="medium"
          iconOnly
          severity="action"
          hint="Start Another Timer"
          [disabled]="_isLoading"
          (clicked)="startTimer()"
          [data-qaa]="_qaaPrefix + '-start-another-button'"
          [attr.data-qaa-id]="timer.id"
        >
          <f360-lum-icon name="plus-square" />
        </f360-lum-button>
      </div>
    </div>
  } @empty {
    <div class="header-timer">
      <f360-lum-button
        variant="secondary-outline"
        size="small"
        severity="action"
        (clicked)="startTimer()"
        [data-qaa]="_qaaPrefix + '-start-button'"
      >
        <f360-lum-icon before name="play" size="small" />
        Start Timer
      </f360-lum-button>
      <f360-lum-button
        variant="secondary-outline"
        size="small"
        severity="action"
        (clicked)="addTime()"
        [data-qaa]="_qaaPrefix + '-add-time-button'"
      >
        <f360-lum-icon before name="plus-circle" size="small" />
        Add Time
      </f360-lum-button>
    </div>
  }
}
